// extracted by mini-css-extract-plugin
export default {"root":"property_rate_plans_per_unit_root__hdo8j","actions_link":"property_rate_plans_per_unit_actions_link__5gmgj"};